import { AssetAffected } from "../../data/Fleet/AssetAffected";
import { AuthorizedBy } from "../../data/Fleet/AuthorizedBy";
import { YesNoSelection } from "../../data/Fleet/YesNoSelection";

export const yardRepairFieldConfiguration = [
  {
    name: "assetAffected",
    label: "Asset Affected",
    type: "select",
    options: AssetAffected,
    validation: { required: "Asset Affected is required" },
  },
  {
    name: "assetNumber",
    label: "Asset Number",
    type: "combo",
    dataKey: "assets",
    validation: { required: "Asset Number is required" },
  },
  {
    name: "driverId",
    label: "Driver",
    type: "combo",
    dataKey: "drivers",
    validation: { required: "Driver is required" },
  },
  {
    name: "ownerCompanyId",
    label: "Company",
    type: "combo",
    dataKey: "ownerCompanies",
    validation: { required: "Company is required" },
  },
  {
    name: "description",
    label: "Description",
    type: "text",
    validation: {
      required: "Description is required",
      minLength: {
        value: 5,
        message: "Description must be at least 5 characters long",
      },
      maxLength: {
        value: 100,
        message: "Description must not exceed 100 characters",
      },
    },
  },
  {
    name: "amount",
    label: "Amount",
    type: "decimal",
    validation: {
      required: "Amount is required",
      pattern: {
        value: /^\d+(\.\d{1,2})?$/,
        message: "Float number separated by dot and maximum 2 decimal places",
      },
    },
  },
  {
    name: "invoiceDate",
    label: "Invoice date",
    type: "text",
    validation: {
      required: "Date is required",
      pattern: {
        value: /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12]\d|3[01])\/(19|20)\d{2}$/,
        message: "Date must be in the format MM/DD/YYYY",
      },
    },
  },
  {
    name: "invoiceNumber",
    label: "Invoice Number",
    type: "text",
    validation: {
      required: "Invoice number is required",
    },
  },
  {
    name: "authorizedBy",
    label: "Authorized By",
    type: "select",
    options: AuthorizedBy,
    validation: {
      required: "Authorized By is required",
    },
  },
  {
    name: "mileage",
    label: "Mileage",
    type: "text",
    validation: {
      required: "Mileage is required",
    },
  },
  {
    name: "isCompanyCharged",
    label: "Is Company Charged",
    type: "select",
    options: YesNoSelection,
  },
  {
    name: "chargedCompanyAmount",
    label: "Charged Company Amount",
    type: "decimal",
    pattern: {
      value: /^\d+(\.\d{1,2})?$/,
      message: "Float number separated by dot and maximum 2 decimal places",
    },
  },
  {
    name: "isDriverCharged",
    label: "Is Driver Charged",
    type: "select",
    options: YesNoSelection,
  },
  {
    name: "chargedDriverAmount",
    label: "Charged Driver Amount",
    type: "decimal",
    pattern: {
      value: /^\d+(\.\d{1,2})?$/,
      message: "Float number separated by dot and maximum 2 decimal places",
    },
  },
];

export const yardRepairInitialValues = {
  assetAffected: "",
  assetNumber: "",
  driverId: "",
  ownerCompanyId: "",
  description: "",
  amount: "",
  invoiceNumber: "",
  authorizedBy: "",
  mileage: "",
  isCompanyCharged: "",
  chargedCompanyAmount: "",
  isDriverCharged: "",
  chargedDriverAmount: "",
};

export const makeFieldConfigDynamic = (
  fields: any[],
  setFieldState: (type: string) => void,
  assetAffected: string
) => {
  return fields.map((field) => {
    if (field.name === "assetAffected") {
      return {
        ...field,
        onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
          setFieldState(event.target.value),
      };
    } else if (field.name === "assetNumber") {
      return {
        ...field,
        disabled: assetAffected === "",
      };
    }
    return field;
  });
};

export const updateYardRepairFieldConfiguration = [
  {
    name: "ownerCompanyId",
    label: "Company",
    type: "combo",
    dataKey: "ownerCompanies",
    validation: { required: "Company is required" },
  },
  {
    name: "description",
    label: "Description",
    type: "text",
    validation: {
      required: "Description is required",
      minLength: {
        value: 5,
        message: "Description must be at least 5 characters long",
      },
      maxLength: {
        value: 100,
        message: "Description must not exceed 100 characters",
      },
    },
  },
  {
    name: "amount",
    label: "Amount",
    type: "decimal",
    validation: {
      required: "Amount is required",
    },
  },
  {
    name: "invoiceDate",
    label: "Invoice date",
    type: "text",
    validation: {
      required: "Date is required",
      pattern: {
        value: /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12]\d|3[01])\/(19|20)\d{2}$/,
        message: "Date must be in the format MM/DD/YYYY",
      },
    },
  },
  {
    name: "invoiceNumber",
    label: "Invoice Number",
    type: "text",
    validation: {
      required: "Invoice number is required",
    },
  },
  {
    name: "authorizedBy",
    label: "Authorized By",
    type: "select",
    options: AuthorizedBy,
    validation: {
      required: "Authorized By is required",
    },
  },
  {
    name: "mileage",
    label: "Mileage",
    type: "text",
    validation: {
      required: "Mileage is required",
    },
  },
  {
    name: "isCompanyCharged",
    label: "Is Company Charged",
    type: "select",
    options: YesNoSelection,
  },
  {
    name: "chargedCompanyAmount",
    label: "Charged Company Amount",
    type: "decimal",
  },
  {
    name: "isDriverCharged",
    label: "Is Driver Charged",
    type: "select",
    options: YesNoSelection,
  },
  {
    name: "chargedDriverAmount",
    label: "Charged Driver Amount",
    type: "decimal",
  },
];

export const makeUpdateFieldConfigDynamic = (fields: any[]) => {
  return fields.map((field) => {
    return field;
  });
};
